import { getContext } from '@/context';

const isAuthorized = (): boolean =>
  getContext().general.auth.getState().isAuthorized ?? false;

export default isAuthorized;
